import React from "react";

const ICON = {
    width: "50",
    height: "50",
    colors: {
        candidate: "#0D7AB6",
        company: "#94D63D"
    }
};

function IconVideo ({ iconType, iconAction }) {
  return (
    iconAction === "add" ?
        <svg xmlns="http://www.w3.org/2000/svg"
        width={ICON.width} height={ICON.height} fill="none" viewBox="0 0 50 50">
        <path
            fill={iconType === "candidate" ? ICON.colors.candidate : ICON.colors.company}
            fillRule="evenodd"
            d="M0 25C0 11.215 11.145 0 24.843 0c13.7 0 24.844 11.215 24.844 25S38.543 50 24.843 50C11.145 50 0 38.785 0 25z"
            clipRule="evenodd"
        ></path>
        <path
            fill="#fff"
            fillRule="evenodd"
            d="M33.675 21.29v8l6.87 4.977v-18l-6.87 5.023zM32.477 31.7c0 2.567-2.833 2.567-2.833 2.567H12.789s-2.833 0-2.833-2.568V18.843c0-2.575 2.833-2.575 2.833-2.575h16.855s2.833 0 2.833 2.575v12.856zM21.773 20.803a.594.594 0 00-1.188 0v3.523h-3.898a.594.594 0 000 1.188h3.898v3.582a.594.594 0 001.188 0v-3.582h3.962a.594.594 0 100-1.188h-3.962v-3.524z"
            clipRule="evenodd"
        ></path>
        </svg> :
        iconAction === "play" ?
        <svg xmlns="http://www.w3.org/2000/svg"
            width="76" height="76" fill="none" viewBox="0 0 76 76">
            <g clipPath="url(#clip0)" filter="url(#filter0_d)">
            <mask id="mask0"
                width="72"
                height="72"
                x="2"
                y="2"
                maskUnits="userSpaceOnUse"
            >
                <path
                fill="#fff"
                fillRule="evenodd"
                d="M2 2h71.227v71.676H2V2z"
                clipRule="evenodd"
                ></path>
            </mask>
            <g mask="url(#mask0)">
                <path
                fill={iconType === "company" ? ICON.colors.company : ICON.colors.candidate}
                fillRule="evenodd"
                d="M2 37.838C2 18.077 17.976 2 37.613 2c19.638 0 35.614 16.077 35.614 35.838 0 19.76-15.976 35.838-35.614 35.838C17.976 73.676 2 57.599 2 37.838z"
                clipRule="evenodd"
                ></path>
            </g>
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M27.083 58.705c-1.42 0-2.532-1.126-2.532-2.564V19.666c0-1.438 1.112-2.564 2.532-2.564.467 0 .94.127 1.365.367l32.341 18.237c.843.475 1.346 1.297 1.346 2.198 0 .9-.503 1.722-1.346 2.197L28.448 58.338a2.79 2.79 0 01-1.365.367z"
                clipRule="evenodd"
            ></path>
            </g>
            <defs>
            <filter
                id="filter0_d"
                width="77.226"
                height="77.676"
                x="-1"
                y="0"
                colorInterpolationFilters="sRGB"
                filterUnits="userSpaceOnUse"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
                <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                ></feColorMatrix>
                <feOffset dy="1"></feOffset>
                <feGaussianBlur stdDeviation="1.5"></feGaussianBlur>
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"></feColorMatrix>
                <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
                ></feBlend>
                <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
                ></feBlend>
            </filter>
            <clipPath id="clip0">
                <path fill="#fff" d="M0 0H76V76H0z"></path>
            </clipPath>
            </defs>
        </svg> :
    <svg width={60} height={60} fill="none">
    <path
        d="M58.303 18.187a3.595 3.595 0 00-3.466-.155l-9.03 4.496v-4.867a3.444 3.444 0 00-3.475-3.478H21.2l-7.888-9.345a3.517 3.517 0 10-5.377 4.535L46.687 55.17a3.513 3.513 0 002.69 1.246c.804 0 1.613-.274 2.275-.834 1.484-1.257 1.647-3.48.39-4.966l-6.235-7.341v-2.297l9.015 4.496c.498.248 1.05.371 1.588.371.644 0 1.32-.176 1.886-.526C59.334 44.677 60 43.544 60 42.322V21.184c0-1.222-.66-2.355-1.697-2.997zM0 17.66v28.185c0 1.946 1.631 3.53 3.577 3.53h30.087L3.448 14.152C1.55 14.207 0 15.75 0 17.661z"
        fill="#6C6C6C"
    />
    </svg>

  );
}

export default IconVideo;
